import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as CryptoJS from 'crypto-js';

import { BaseChartDirective } from 'ng2-charts/ng2-charts';
import { ReportsService } from '../../../../reports/services/reports.service';
import { DashboardService } from '../../../services/dashboard.service';
import { CookieManagerService } from '../../../../../shared/services/cookie-manager.service';

import { Constants } from '../../../../../app.const';
import { WorkConstants } from "../../../../work/work.const";
import { TranslateService } from 'ng2-translate';
declare var $: any;

@Component({
  selector: 'app-my-chart',
  templateUrl: './my-chart.component.html',
  providers: [DashboardService]
})
export class MyChartComponent implements OnInit {
  @ViewChild(BaseChartDirective) chart: BaseChartDirective;

  date: string;
  authUser: any = {};
  workConstants: any = WorkConstants;
  my_attendance_sheets: any = {
    user_name: [],
    user_times: []
  };

  my_time_sheets: any = {
    user_name: [],
    user_times: []
  };

  my_leave_sheets: any = {
    user_name: [],
    user_times: []
  };

  lastMonthFirstDate: Date;
  lastMonthLastDate: Date;
  currentMonthFirstDate: Date;
  currentMonthLastDate: Date;
  currentyearFirstDate: Date;
  currentyearLastDate: Date;
  currentDate: Date = new Date();

  private constants = Constants;
  constructor(
    private datePipe: DatePipe,
    private reportsService: ReportsService,
    private cookieManagerService: CookieManagerService,
    private dashboardService: DashboardService,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    let $this = this;
    let date = new Date();
    this.getAuthUser();
    // define dates
    this.lastMonthFirstDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    this.lastMonthLastDate = new Date(date.getFullYear(), date.getMonth(), 0)
    this.currentMonthFirstDate = new Date(date.getFullYear(), date.getMonth(), 1);
    this.currentMonthLastDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.currentyearFirstDate = new Date(date.getFullYear(), 0, 1);
    this.currentyearLastDate = new Date(date.getFullYear() + 1, 0, 0);

    // default my char details for yesterday
    this.getTimeSheetAndAttendanceByDateForMyChart(this.datePipe.transform(this.currentMonthFirstDate, this.constants.dateFormat), this.datePipe.transform(this.currentMonthLastDate, this.constants.dateFormat));
    // get attendance details for today
    this.getAttendanceByEmpIdAndDate(this.authUser['emp_number'],this.datePipe.transform(date, this.constants.dateFormat));

    // my chart details
    $('#myChartDate').val(this.currentDate.getFullYear() + '-' + this.currentDate.getMonth());
    $('#myChartDatediv').datepicker({
      autoclose: true,
      viewMode: "months",
      minViewMode: "months",
      changeMonth: true,
      changeYear: true,
      format: 'yyyy-mm'
    }).on('changeDate', function (selected) {
      let selectDate = new Date(selected.date.valueOf());
      var date = new Date(selectDate), y = date.getFullYear(), m = date.getMonth();
      var firstDay = new Date(y, m, 1);
      var lastDay = new Date(y, m + 1, 0);

      $this.date = $this.datePipe.transform(selectDate, $this.constants.dateFormat);
      // get time sheet on chagne
      $this.getTimeSheetAndAttendanceByDateForMyChart($this.datePipe.transform(firstDay, $this.constants.dateFormat), $this.datePipe.transform(lastDay, $this.constants.dateFormat));
    });

  }

  /**
   * Timesheet My time chart
  */
  public timesheetMyChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public timesheetMyChartLabels: string[] = [];
  public timesheetMyChartType: string = 'bar';
  public timesheetMyChartLegend: boolean = true;

  public timesheetMyChartData: any[] = [
    { data: [], label: this.translateService.instant('WORKINGhOURS') },
    { data: [], label: this.translateService.instant('ATTENDANCE') },
    { data: [], label: this.translateService.instant('LEAVE') },
  ];

  public timesheetMyChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(26,179,142,1)', // color of timesheet
      stack: 'timeSheet',
    },
    {
      backgroundColor: '#676a6c', // color of attendance
      stack: 'attendance',
    },
    {
      backgroundColor: '#f8ac59', // color of leave
       stack: 'attendance',
    }
  ];

  /**
   * Get timesheet and Attendance by given date for graph  
   * 
   * @param {any} toDate 
   * @param {any} fromDate
   * @memberOf TimesheetComponent
   */
  getTimeSheetAndAttendanceByDateForMyChart(toDate, fromDate) {    
    // change the label
    this.changeLabelForDateRange(toDate, fromDate);
    var userId = this.authUser['emp_number'];
    this.reportsService.getTimeSheetAndAttendanceForMyChart({ toDate, fromDate, userId }).subscribe(
      res => {
        this.my_time_sheets = res.data.time_sheets;
        this.my_attendance_sheets = res.data.attendance_sheets;
        this.my_leave_sheets = res.data.leave_sheets;

        this.timesheetMyChartData = [
          { data: this.my_time_sheets.user_time, label: this.translateService.instant('WORKINGhOURS') },
          { data: this.my_attendance_sheets.attendance_time, label: this.translateService.instant('ATTENDANCE') },
          { data: this.my_leave_sheets.leave_time, label: this.translateService.instant('LEAVE') },
        ];

        this.timesheetMyChartLegend = true;
        this.timesheetMyChartLabels = [];
        this.timesheetMyChartLabels = this.my_time_sheets.user_date;

        if (this.chart && this.chart.chart && this.chart.chart.config) {
          this.chart.chart.config.data.labels = this.my_time_sheets.user_date;
          this.chart.chart.update();
        }
      }
    );
  }

  showDatePickerInMyChart() {
    // show the custom calander
    $('#my-custom-date').show();
    // add and remove the "active" class
    $('#myChartCustom').addClass('active');
    $('.my-chart-button').removeClass('active');
  }

  showMyChartInDateRangeForMonth(event, toDate, fromDate) {
    // get the id from the event
    var idAttr = event.target.id;
    // hide the calander
    $('#my-custom-date').hide();
    //remove and add new class
    $('.my-chart-button').removeClass('active');
    $('#'+idAttr).addClass('active');

    var toDateAttr = this.datePipe.transform(toDate, this.constants.dateFormat);
    var fromDateAttr = this.datePipe.transform(fromDate, this.constants.dateFormat);
    this.getTimeSheetAndAttendanceByDateForMyChart(toDateAttr, fromDateAttr)
  }

  showMyChartInDateRangeForYear(event, toDate, fromDate) {    
    // get the id from the event
    var idAttr = event.target.id;
    // hide the calander
    $('#my-custom-date').hide();
    //remove and add new class
    $('.my-chart-button').removeClass('active');
    $('#'+idAttr).addClass('active');

    var toDateAttr = this.datePipe.transform(toDate, this.constants.dateFormat);
    var fromDateAttr = this.datePipe.transform(fromDate, this.constants.dateFormat);
    this.getTimeSheetAndAttendanceByDateForMyChartForMonth(toDateAttr, fromDateAttr)
  }

  /**
   * Get timesheet and Attendance by given date for graph  
   * 
   * @param {any} toDate 
   * @param {any} fromDate
   * @memberOf TimesheetComponent
   */
  getTimeSheetAndAttendanceByDateForMyChartForMonth(toDate, fromDate) {
    // change the label
    this.changeLabelForDateRange(toDate, fromDate);
    var userId = this.authUser['emp_number'];
    this.reportsService.getTimeSheetAndAttendanceForMyChartShortingMonth({ toDate, fromDate, userId }).subscribe(
      res => {
        this.my_time_sheets = res.data.time_sheets;
        this.my_attendance_sheets = res.data.attendance_sheets;
        this.my_leave_sheets = res.data.leave_sheets;

        this.timesheetMyChartData = [];
        this.timesheetMyChartData = [
          { data: [], label: 'Timesheet' },
          { data: [], label: 'Attendance' },
        ];
        this.timesheetMyChartData = [
          { data: this.my_time_sheets.user_time, label: 'Working hours' },
          { data: this.my_attendance_sheets.attendance_time, label: 'Attendance' },
          { data: this.my_leave_sheets.leave_time, label: 'Leave' },
        ];
        
        this.timesheetMyChartLegend = true;
        this.timesheetMyChartLabels = [];
        this.timesheetMyChartLabels = this.my_time_sheets.user_date;

        if (this.chart && this.chart.chart && this.chart.chart.config) {
          this.chart.chart.config.data.labels = this.my_time_sheets.user_date;
          this.chart.chart.update();
        }
      }
    );
  }

/**
 * kaushalya
 * 2017-07-03
 * get log user details from the cookies
 */
  getAuthUser() {
    let userToken = this.cookieManagerService.getCookie(WorkConstants.basicConstans.userToken, false);
    this.authUser = JSON.parse(CryptoJS.AES.decrypt(userToken, WorkConstants.basicConstans.userKey).toString(CryptoJS.enc.Utf8));
  }

/**
 * kauhsalya
 * 2017-07-27
 * change the label of the date range in my chart component
 */
 changeLabelForDateRange(startDate,endDate){
   var text = "For ( "+startDate+" - "+endDate+" )";
    $('#myTimeSheetCustomDataValue').text(text);
 }

/**
 * kaushlya
 * 2017-07-28
 * get employee attendance details
 */
 getAttendanceByEmpIdAndDate(employeeId, dateTime) {
    this.dashboardService.getAttendanceByEmpIdAndDate({ employeeId, dateTime }).subscribe(
      res => {
        if(res.data.attendanceLength <= 0){
           $('#myAtendancePunchInNote').show();
        }else{            
          $('#myAtendancePunchInNote').hide();       
        }
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/maindashboard/my-chart/my-chart.component.ts